import type { SVGProps } from "react";

function LandPlotBase() {
  return (
    <>
      <path d="m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12" />
      <path d="m6.49 12.85 11.02 6.3" />
      <path d="M17.51 12.85 6.5 19.15" />
    </>
  );
}

/** JPB: LuLandPlot without flag + dollar sign (LuCircleDollarSign paths, no circle). */
export function JPBModuleLandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <LandPlotBase />
      <g
        transform="translate(12 5) scale(0.78) translate(-12 -12)"
        strokeWidth={2}
        vectorEffect="non-scaling-stroke"
      >
        <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
        <path d="M12 18V6" />
      </g>
    </svg>
  );
}

/** Mølbak index: LuLandPlot without flag + LuTrendingUp raised above the parcel. */
export function JPBMolbakIndexLandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <LandPlotBase />
      <g
        transform="translate(13 3.6) scale(0.58) translate(-12 -10)"
        strokeWidth={2.1}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
        <polyline points="16 7 22 7 22 13" />
      </g>
    </svg>
  );
}
